import { render } from "./MetaAds.vue?vue&type=template&id=13d8e06c&scoped=true"
import script from "./MetaAds.vue?vue&type=script&lang=js"
export * from "./MetaAds.vue?vue&type=script&lang=js"

import "./MetaAds.vue?vue&type=style&index=0&id=13d8e06c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d8e06c"]])

export default __exports__